"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var elog = require("../../elog");
var classNames = require("classnames");
var core_link_1 = require("../../components/core_link");
var markdown_output_1 = require("./markdown_output");
var url_helpers_1 = require("../../url_helpers");
var COMPONENT_NAME = 'CallToAction';
var CallToAction = /** @class */ (function (_super) {
    tslib_1.__extends(CallToAction, _super);
    function CallToAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CallToAction.prototype.imageURI = function () {
        return url_helpers_1.imageUploadURL(this.props.backgroundImageKey, this.props.cdn);
    };
    CallToAction.prototype.getBackgroundImageStyle = function () {
        if (!this.props.backgroundImageKey)
            return null;
        return {
            style: { backgroundImage: "url('" + this.imageURI() + "')" },
        };
    };
    CallToAction.prototype.render = function () {
        try {
            var classes = classNames('call-to-action', { 'call-to-action--white': this.props.backgroundColor === 'white' }, { 'call-to-action--offwhite': this.props.backgroundColor === 'offwhite' }, { 'call-to-action--blue': this.props.backgroundColor === 'blue' }, { 'call-to-action--blue-lp': this.props.backgroundColor === 'blue-lp' }, { 'call-to-action--orange': this.props.backgroundColor === 'orange' });
            return (React.createElement("div", tslib_1.__assign({ className: classes, id: this.props.jumplinkSlug }, this.getBackgroundImageStyle()),
                React.createElement("div", { className: "call-to-action__inner" },
                    React.createElement(markdown_output_1.default, { htmlTag: "h3", className: "call-to-action__heading", text: this.props.heading, textHtml: this.props.headingHtml, inlineTagsOnly: true, blacklistedTags: ['a'] }),
                    React.createElement(markdown_output_1.default, { htmlTag: "h4", className: "call-to-action_subheading", text: this.props.subheading, textHtml: this.props.subheadingHtml, inlineTagsOnly: true, blacklistedTags: ['a'] }),
                    React.createElement("div", { className: "call-to-action__link-container" },
                        React.createElement(core_link_1.default, { className: "call-to-action__link", to: this.props.ctaTargetHref }, this.props.ctaText)))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    return CallToAction;
}(React.Component));
exports.default = CallToAction;
//# sourceMappingURL=call_to_action.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/call_to_action.js
// module id = zLim
// module chunks = 0 2 6 20